export const ONBOARDING_PATH = "/onboarding";
export const INVOICE_PATH = "/invoices";
export const EOR_PROFILE_PATH = "/employee-profile";
export const ADDITIONAL_PAYMENTS = "/masspay";
